module.exports = __webpack_public_path__ + "static/14-f00756edea379a86849f9561324653ec.jpg";